import assign = require('object-assign');
import { ADD, DELETE } from '../constants/Widget';
import { GET_SUCCESS } from '../constants/ReportTemplate';

import { IWidgetAction } from '../interfaces/actions';
import { IWidgetUsageCountState } from '../interfaces/states';

const initialState: IWidgetUsageCountState = {};

export default function widgetUsageCounts(state = initialState, action : IWidgetAction): IWidgetUsageCountState {
    let modifier = 1;

    switch (action.type) {
        case DELETE: { 
            modifier = -1; 
        }
        case ADD: {
            let widget = action.payload.widget;
            let newState = assign({}, state);
            if(!state[widget.type]) {
                newState[widget.type] = 0;
            } else {
                newState[widget.type] = state[widget.type]; 
            }

            newState[widget.type] = newState[widget.type] + modifier;

            return newState;
        }
        case GET_SUCCESS: {
            let widgets = (action.payload || {}).widgets || [];
            let newState = {};

            widgets.forEach((widget) => {
                newState[widget.type] = (newState[widget.type] || 0) + 1;
            });

            return newState;
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/widgetUsageCounts.ts